const prop = (obj, attr) => obj[attr];

export function getBaseUrl(noPort) {
  const href = prop(window.location, 'href')
  const port = prop(window.location, 'port')
  let path = prop(window.location, 'pathname');
  let startPos = prop(window.location, 'protocol').length + 2;
  let pos = href.indexOf(path, startPos);
  let host = href.substring(0, pos);
  let baseUrl = host + '/';

  if(noPort && port && port.length>0){
    baseUrl = baseUrl.replace(':' + port, '')
  }
  return baseUrl;
};